import { has } from "../../../../utils/menu-context";
import { callFeeType } from "./fee.logic";
import store from "../../../../store";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitPayment", "reEdit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitPayment", "waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitPayment: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["3"].includes(record.refType?.key)) {
                    if (["waitReceive"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canWaitReceive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitPayment", "reEdit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitPayment", "waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["3"].includes(record.refType?.key)) {
                    if (["waitReceive"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            let result = true;
            if (["excludeFee"].includes(record.refStatus?.key)) {
                result = false;
            }
            return result;
        },
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refType"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { menuContext, viewOnly } = props;
                return {
                    disabled: viewOnly || ["waitReceive", "waitApprove", "approve"].includes(modelRef?.refStatus?.key),
                    list: ({ searchQuery }) => callFeeType({ searchQuery }).then(d => d.filter(refFeeType => {
                        let keys = [];
                        if (has({ menuContext, key: "forRequest" })) {
                            if(modelRef.lastUserBank?.active?.[0]) {
                                keys = [modelRef.lastUserBank?.active?.[0]?.refPayBy?.key, "3"]
                            } else {
                                keys = ["3"]
                            }
                        }
                        if (has({ menuContext, key: "forReceive" })) {
                            if (["waitPayment"].includes(modelRef.refStatus?.key)) {
                                keys = ["3", "4"]
                            }
                        }
                        return keys.includes(refFeeType.key)
                    })),
                };
            }
        },
        {
            check: ({ field }) => {
                return ["payDatetime", "requesterRemark"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refType;
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                return {
                    disabled: viewOnly || ["waitReceive", "waitApprove", "approve"].includes(modelRef?.refStatus?.key) || ["1", "2"].includes(modelRef.refType?.key),
                };
            }
        },
        {
            check: ({ field }) => {
                return ["refKtb.resTranxId", "refKtb.resBankRef", "refKtb.reqComCode", "refKtb.reqEffDate", "refKtb.resRespCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refType?.key === "5"
            }
        },
        {
            check: ({ field }) => {
                return ["refKtbPaynet.payService", "refKtbPaynet.payRef", "refKtbPaynet.ktbRef", "refKtbPaynet.vendorId", "refKtbPaynet.rspCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refType?.key === "1"
            }
        },
        {
            check: ({ field }) => {
                return ["nswServiceLogs"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                const { menuContext } = props;
                if (has({ menuContext, key: "forReceive" })) {
                    return modelRef.refType?.key === "2";
                }
                if (has({ menuContext, key: "forApprove" })) {
                    return modelRef.refType?.key === "2";
                }
                if (store.state?.resource?.auth?.info?.user?.refOfficerLv) {
                    return modelRef.refType?.key === "2";
                }
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["officerRemark"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refType;
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                return {
                    disabled: viewOnly || ["reEdit", "waitPayment"].includes(modelRef?.refStatus?.key) || ["1", "2"].includes(modelRef.refType?.key),
                };
            }
        },
        {
            check: ({ field }) => {
                return ["customerName"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refType;
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                return {
                    disabled: viewOnly || ["waitReceive", "waitApprove", "approve"].includes(modelRef?.refStatus?.key) || ["1", "2"].includes(modelRef.refType?.key),
                };
            }
        },
        {
            check: ({ field }) => {
                return ["attachments"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                return { disabled: viewOnly || ["waitReceive", "waitApprove", "approve"].includes(modelRef?.refStatus?.key) };
            }
        },
        {
            check: ({ field }) => {
                return ["refBank", "branch", "refBankType", "branchCode", "bankName", "bankAccount"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let result = false;
                if (["1", "2"].includes(modelRef.refType?.key)) {
                    result = true || result;
                }
                return result;
            }
        },
        {
            check: ({ field }) => {
                return ["attachments"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let result = false;
                if (["3"].includes(modelRef.refType?.key)) {
                    result = true || result;
                }
                return result;
            }
        },
        {
            check: ({ field }) => {
                return ["refOfficer.fullNameTh"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let result = false;
                if (["waitPayment"].includes(modelRef?.refStatus?.key) && ["4"].includes(modelRef.refType?.key)) {
                    result = true || result;
                }
                if (["waitApprove", "approve"].includes(modelRef?.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            }
        },
    ];
};
